import { useEffect } from 'react';
import { initKeycloak, cleanupKeycloakResources } from '@/utils/auth/keycloak-instance';

/**
 * Component to initialize Keycloak on app load
 * This ensures Keycloak instance is always initialized for SSO detection
 * and cross-tab synchronization
 */
export const KeycloakInitializer: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  useEffect(() => {
    const initialize = async () => {
      // Always initialize Keycloak for SSO check and cross-tab sync
      try {
        const authenticated = await initKeycloak();
        if (authenticated) {
          console.log('Keycloak already authenticated');
        } else {
          console.log('Keycloak initialized for SSO detection');
        }
      } catch (error) {
        console.error('Failed to initialize Keycloak:', error);
      }
    };

    initialize();

    // Cleanup on unmount
    return () => {
      cleanupKeycloakResources();
    };
  }, []);

  // Don't block rendering, just initialize in background
  return <>{children}</>;
};
